<template>
  <div class="list-page-layout">
    <div v-if="$slots.filter" class="list-page-layout__filter">
      <slot name="filter"></slot>
    </div>
    <div v-if="$slots.toolbar" class="list-page-layout__toolbar">
      <slot name="toolbar"></slot>
    </div>
    <div
      class="list-page-layout__table list-right"
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <slot></slot>
    </div>
    <div v-if="$slots.pagination" class="list-page-layout__pagination">
      <slot name="pagination"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListPageLayout",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.list-page-layout {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.list-page-layout__filter {
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
}

.list-page-layout__toolbar {
  flex-shrink: 0;
  margin-bottom: 8px;
  padding: 8px 10px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.list-page-layout__table {
  flex: 1;
  min-height: 0;
  position: relative;
}

.list-page-layout__pagination {
  flex-shrink: 0;
  position: relative;
  min-height: 56px;
}
</style>
